/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Col,
  Modal,
  Input,
  DatePicker,
  message,
} from 'antd';
import Table from 'components/Table';
import { onError } from 'utils/handlers';
import PercentageInput from 'components/PercentageInput';
import percentFormatter from 'utils/percentFormatter';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { getEstadosGlobales } from 'api/catalogos';
import { getTiposDeDepositos } from 'api/catalogos/tiposDeDepositos';
import { getBancos } from 'api/configuraciones/bancos';
import {
  getBeneficiariosExternos,
  postBeneficiarioExterno,
  patchBeneficiarioExterno,
  deleteBeneficiarioExterno,
  getBeneficiarioExterno,
} from 'api/nominas/descuentos/beneficiariosExternos';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';
import { getDocumentosEmpleadosParams } from 'api/catalogos/documentosEmpleados';
import FormItem from 'antd/es/form/FormItem';
import API from 'utils/api';
import { getTiposDeDocumentos } from 'api/catalogos/tiposDeDocumentos';
import { DownloadOutlined } from '@ant-design/icons';
import Uploader from 'components/Uploader';
import moment from 'moment';
import {
  deleteDocumentosPercepcion,
  getDocumentosPercepcion,
  getDocumentosPercepciones,
  patchDocumentosPercepcion,
  postDocumentosPercepcion,
} from 'api/nominas/percepciones/PercepcionesAdjuntos';

const Adjuntos = ({
  permissions,
  selected,
  disable,
  isBlocked,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState();
  const [estados, setEstados] = useState([]);
  const [esTransferencia, setEsTransferencia] = useState(false);
  const [esClabe, setEsClabe] = useState(false);
  const [tipoDeDocumento, setTipoDeDocumento] = useState();
  const [formFormaPago] = Form.useForm();
  const [porcentajes, setPorcentajes] = useState(0);
  const [editable, setEditable] = useState(false);
  const [porcentajeSeleccionado, setPorcentajeSeleccionado] = useState(0);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [tiposDeDocumentos, setTiposDeDocumentos] = useState([]);
  const [pageActual, setPageActual] = useState(1);

  const formInstances = [
    form,
    formDatos,
    formFormaPago,
  ];

  // const fetchData = async () => {
  //   setLoading(true);
  //   const _data = await getDocumentosPercepciones({ descuento_empleado: selected });
  //   setData(formatReceived(_data));
  //   setLoading(false);
  //   return _data;
  // };

  const getFechaServidor = async () => ({ fecha: new Date().toISOString() });

  const obtenerFechaServidorYSetear = async () => {
    try {
      const { fecha } = await getFechaServidor(); // retorna string tipo "2025-06-24T18:15:00Z"
      form.setFieldsValue({
        fecha_de_carga: moment(fecha), // ⬅️ convertir string ISO a moment
      });
    } catch (err) {
      message.error('No se pudo obtener la fecha del servidor');
    }
  };

  const baseURI = '/nominas/descuentos-empleados-adjuntos';

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await API.get(baseURI, { params: { page, descuento_empleado: selected, ...q } });
    const { results } = _data.data;
    setData({ ..._data.data, results });
    setLoading(false);
  };
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await API.get(baseURI, {
        params: { page: cleanPage, descuento_empleado: selected, ...q },
      });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _estados,
        _tiposDeDocumentos,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeDocumentos(),
        getDocumentosPercepciones({ descuento_empleado: selected }),
      ]);
      const { results } = _data;
      if (mounted) {
        if (selected) {
          setEstados(_estados);
          setTiposDeDocumentos(_tiposDeDocumentos);
          setData({ ..._data, results });
          setLoading(false);
        } else {
          setData({ ..._data, results });
          setLoading(false);
        }
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [selected]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setEsTransferencia(false);
    setEditable(false);
    setEsClabe(false);
    form.resetFields();
    formDatos.resetFields();
  };

  const onClickAdd = async () => {
    if (!selected) {
      message.warning('Guarde el Descuento de Empleado antes de agregar adjuntos.');
      return;
    }
    onCancel();
    setVisible(true);
    await obtenerFechaServidorYSetear();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setEditable(true);

    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);

    try {
      const documento = await getDocumentosPercepcion(match.id);

      // Convertir fecha correctamente
      if (documento.fecha_de_carga && typeof documento.fecha_de_carga === 'string') {
        documento.fecha_de_carga = moment(documento.fecha_de_carga);
      }

      // Cargar en formularios
      form.setFieldsValue(formatReceived(documento));
      formDatos.setFieldsValue(formatReceived(documento));

      setVisible(true);
    } catch (error) {
      message.error('Error al cargar el documento.');
    }

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();

      const rawValues = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };

      // Asegurar campo obligatorio
      rawValues.descuento_empleado = selected;

      const formData = new FormData();
      Object.entries(rawValues).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === 'archivo') {
            // Solo se envía si el usuario seleccionó un archivo nuevo.
            // Si no, se omite para no sobrescribir el archivo ya guardado
            // con la URL de texto que trae el formulario al editar.
            if (value instanceof File) {
              formData.append(key, value);
            }
          } else if (moment.isMoment(value)) {
            formData.append(key, value.format('YYYY-MM-DD'));
          } else {
            formData.append(key, value);
          }
        }
      });

      const [key] = selectedRowKeys;
      const saved = key
        ? await patchDocumentosPercepcion(key, formData)
        : await postDocumentosPercepcion(formData);

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDocumentosPercepcion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);

    const newRecord = {
      ...record,
      fecha_de_carga: record.fecha_de_carga ? moment(record.fecha_de_carga) : null,
    };

    form.setFieldsValue(newRecord);
  };

  const onClickDownload = () => {
    const clone = [...(data?.results || [])];
    const [key] = selectedRowKeys;
    const match = clone.find((e) => e.id === key);

    if (!match?.archivo) {
      message.warning('Este documento no tiene archivo disponible para descargar.');
      return;
    }

    window.open(match.archivo, '_blank', 'noopener,noreferrer');
  };

  const limitMB = 5;
  const allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf'];

  const handleUploadChange = ({ file }) => {
    const realFile = file.originFileObj || file;

    if (!(realFile instanceof File)) {
      message.error('El archivo no es válido.');
      return;
    }

    const { name } = realFile;
    const extension = name.split('.').pop().toLowerCase();
    const baseName = name.replace(/\.[^/.]+$/, '');

    form.setFieldsValue({
      archivo: realFile,
      archivo_nombre: name,
      extension_del_documento: extension,
      nombre_de_documento: baseName,
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 300,
    },
    {
      titleText: 'Fecha de Carga',
      dataIndex: 'fecha_de_carga',
      key: 'fecha_de_carga',
      width: 400,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Nombre De Documento',
      dataIndex: 'nombre_de_documento',
      key: 'nombre_de_documento',
      width: 300,
    },

    {
      titleText: 'Archivo',
      dataIndex: 'archivo_nombre',
      key: 'archivo_nombre',
      width: 300,
    },

    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data?.results || []}
          rowSelection={rowSelection}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          allowExport
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: onClickDownload,
              icon: <DownloadOutlined />,
              text: 'Descargar Documento',
              disabled: !selectedRowKeys.length,
            },
          ]}
          allowDelete={!disable}
          permission={permissions}
          allowExportPDF={false}
          disableAdd={disable || isBlocked || !selected}
        />
        <Modal
          open={open}
          width={700}
          closable={false}
          maskClosable={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Documento Adjunto`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disable}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            name="general"
            disabled={disable}
          >
            <Col xs={24} sm={8}>
              <Form.Item
                name="fecha_de_carga"
                label="Fecha de Carga"
                hasFeedback
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="nombre_de_documento"
                label="Nombre de Documento"
              >
                <Input disabled />
              </Form.Item>

            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="archivo_nombre"
                label="Nombre del archivo"

              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="extension_del_documento"
                label="Extension"
              >
                <Input disabled />

              </Form.Item>
            </Col>

            <Form.Item
              name="archivo"
              label="Documento"
              valuePropName="file"

            >
              <Uploader
                title="Documento"
                limitMB={limitMB}
                allowedExtensions={allowedExtensions}
                allowPreview={false}
                onChange={handleUploadChange}
              />
            </Form.Item>
          </Form>
        </Modal>

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Documento Adjunto ${form.getFieldValue('nombre_de_documento') || ''}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};
export default Adjuntos;
